<div class="content-body" data-testid="content-viewer-container">
	<markdown [data]="content || ''"></markdown>
</div>

<div class="content-footer">
	<div class="download-buttons">
		<button class="download-btn" (click)="onDownloadWord()" data-testid="content-viewer-btn-download-word">
			<mat-icon>description</mat-icon>
			Download Word
		</button>
		<button class="download-btn" (click)="onDownloadPdf()" data-testid="content-viewer-btn-download-pdf">
			<mat-icon>picture_as_pdf</mat-icon>
			Download PDF
		</button>
		<button class="download-btn" (click)="onCopyContent()" data-testid="content-viewer-btn-copy">
			<mat-icon>{{ contentCopied ? 'done' : 'content_copy' }}</mat-icon>
			{{ contentCopied ? 'Copied' : 'Copy Text' }}
		</button>
	</div>
</div>
